'use client';
import { useSideNavOpen } from '@/store';
import React, { useEffect, useState } from 'react';

interface SectionTitleProps {
	title: string;
}

const SectionTitle = ({ title }: SectionTitleProps) => {
	const sideNavOpen = useSideNavOpen();
	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!sideNavOpen && isMounted) return null;
	return <p className="text-sm font-bold  p-2.5">{title}</p>;
};

export default SectionTitle;
